import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-cart',
    imports: [MatIconModule, MatTooltipModule],
    templateUrl: './cart.component.html',
    styleUrl: './cart.component.css'
})
export class CartComponent {

  @Input() localCart: any = [];
  @Output() onItemRmovedEvent = new EventEmitter<any>();

  constructor() {}


  onGetOrderTotal() {
    return this.localCart.totalFormatted;
  }

  onGetTotalWeight() {
    let totalWeight = 0;
    this.localCart.items.forEach((cartItem: any) => {
       totalWeight += cartItem.weight * cartItem.quantity; 
    });
    return totalWeight;
  }

  onItemRemoval(i: number) {
    this.onItemRmovedEvent.emit(i);
  }

}
